import { Bootstrap } from '../../types/bootstrap';

declare global {
    interface Window {
        process: any;
        Mhecomm_Editor: boolean;
        grecaptcha: any;
        turnstile: any;
        bootstrap: Bootstrap;
        mhPageCategory?: string;
    }
}

window.process = {
    env: {
        NODE_ENV: 'production'
    }
}

export default window;
